import { useAuthApi } from './useAuthApi';
import { useAuthGetters } from './useAuthGetters';
import { useAuthHelpers } from './useAuthHelpers';
import { useConfigHelpers } from './useConfigHelpers';

import type { UseDjustAuth } from './types';
export function useDjustAuth(): UseDjustAuth {
  return {
    ...useAuthApi(),
    ...useAuthGetters(),
    ...useAuthHelpers(),
    ...useConfigHelpers(),
  };
}
